import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { bookingSearchReducer } from './booking-search.reducer';
import { BOOKING_SEARCH_STORE_NAME, BookingSearchState } from './booking-search.state';

/** Token of the BookingSearch reducer */
export const BOOKING_SEARCH_REDUCER_TOKEN = new InjectionToken<ActionReducer<BookingSearchState, Action>>(
  'Feature BookingSearch Reducer'
);

/** Provide default reducer for BookingSearch store */
export function getDefaultBookingSearchReducer() {
  return bookingSearchReducer;
}

@NgModule({
  imports: [StoreModule.forFeature(BOOKING_SEARCH_STORE_NAME, BOOKING_SEARCH_REDUCER_TOKEN)],
  providers: [{ provide: BOOKING_SEARCH_REDUCER_TOKEN, useFactory: getDefaultBookingSearchReducer }],
})
export class BookingSearchStoreModule {
  public static forRoot<T extends BookingSearchState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<BookingSearchStoreModule> {
    return {
      ngModule: BookingSearchStoreModule,
      providers: [{ provide: BOOKING_SEARCH_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
